import { usePointerScene } from './motion';
import './trackerVisuals.css';

/* Same rank pattern as the original flat grid, raised into an isometric plane. */
const CELLS = Array.from({ length: 25 }, (_, index) => {
  const rank = (index * 3) % 19 + 1;
  return { rank, tier: rank <= 3 ? 'strong' : rank <= 9 ? 'mid' : 'low' };
});

export function RankGrid3D() {
  const scene = usePointerScene();
  return (
    <div className="tracker-visual rankgrid" ref={scene.ref} onPointerMove={scene.onPointerMove} onPointerLeave={scene.onPointerLeave}>
      <div className="rankgrid-scene" aria-hidden="true">
        {CELLS.map((cell, index) => (
          <span
            key={index}
            className={`rankgrid-cell is-${cell.tier}`}
            style={{ '--lift': `${Math.max(2, (20 - cell.rank) * 1.7)}px`, '--i': index }}
          >
            {cell.rank}
          </span>
        ))}
      </div>
    </div>
  );
}

const BARS = [
  { width: '84%', label: 'Maps' },
  { width: '65%', label: 'Search' },
  { width: '48%', label: 'Maps' },
  { width: '32%', label: 'Search' },
];

export function KeywordBars3D() {
  const scene = usePointerScene();
  return (
    <div className="tracker-visual keybars" ref={scene.ref} onPointerMove={scene.onPointerMove} onPointerLeave={scene.onPointerLeave}>
      <div className="keybars-scene" aria-hidden="true">
        {BARS.map((bar, index) => (
          <span key={bar.width} className="keybars-bar" style={{ '--w': bar.width, '--i': index }} />
        ))}
      </div>
    </div>
  );
}
